<template>
  <base-edit :fields="fields" :resourceName="resourceName" :pk="pk" :breadcrumbs="breadcrumbs">
    <template slot="images" slot-scope="{ input }">
      <ImageList
              :input.sync="input"
              :resourceName="resourceName"
              mode="edit"
              :multi="false"
      />
    </template>
    <template slot="genres" slot-scope="{ input }">
      <Genre
              :input.sync="input"
              :resourceName="resourceName"
              mode="edit"
              :required="true"
      />
    </template>
  </base-edit>
</template>

<script>
  import ImageList from '../../components/field/images-list';
  import Genre from '../../components/field/genre';

export default {
  components: {
    ImageList,
    Genre
  },
  props: {
    pk: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      resourceName: "topics",
      fields: [
        {
          label: "特集ページ名",
          name: "title",
          rules: "required|max:255",
          width: "60%"
        },
        {
          label: "特集ページURL",
          name: "url",
          rules: "required",
          width: "60%"
        },
        {
          label: "特集ページサムネイル画像",
          name: "images",
          type: "custom"
        },
        {
          label: "ジャンル",
          name: "genres",
          type: "custom"
        },
        {
          label: "メーカー名",
          name: "maker_id",
          type: 'select',
          optionType: "common/makers",
          width: "60%"
        },
        {
          label: "公開期間 from",
          name: "publish_from",
          rules: "lessThanEqual:@publish_to",
          type: "date"
        },
        {
          label: "公開期間 to",
          name: "publish_to",
          rules: "greaterThanEqual:@publish_from",
          type: "date"
        },
        {
          label: "有料会員向けフラグ",
          name: "for_paid_user",
          type: "radio",
          textKey: "text",
          valueKey: "value",
          selects: [
            {
              text: "全会員向け",
              value: 0
            },
            {
              text: "有料会員向け",
              value: 1
            }
          ]
        },
        {
          label: "公開",
          name: "published",
          type: "checkbox",
          textKey: "label",
          valueKey: "value",
          selects: [
            {
              label: "公開",
              value: 1
            }

          ]
        }
      ]
    };
  },
  computed: {
    breadcrumbs() {
      return [
        {
          text: "特集ページ一覧",
          disabled: false,
          to: `/${this.resourceName}`
        },
        {
          text: "特集ページ編集",
          disabled: true
        }
      ];
    }
  }
};
</script>
